import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  { class: 'Math 101', rate: 95 },
  { class: 'Science 201', rate: 88 },
  { class: 'History 301', rate: 92 },
  { class: 'English 401', rate: 85 },
];

function abbreviateClassName(name) {
  // Split by space, abbreviate words longer than 6 chars (except numbers)
  return name.split(' ').map(word => {
    if (/^\d+$/.test(word)) return word; // keep numbers
    if (word.length > 6) return word.slice(0, 3) + '.';
    return word;
  }).join(' ');
}

function CustomTick({ x, y, payload }) {
  return (
    <text x={x} y={y + 10} textAnchor="middle" fill="#94a3b8" fontSize="11">
      {abbreviateClassName(payload.value)}
    </text>
  );
}

export default function AttendanceClassComparisonChart() {
  return (
    <div className="bg-white rounded-xl shadow p-6 h-[300px] flex flex-col">
      <div className="font-semibold text-lg text-slate-800 mb-2">Class Comparison</div>
      <div className="flex-1 flex items-end justify-center">
        <ResponsiveContainer width="100%" height={180}>
          <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorAttendanceBarVerticalClassComparison" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2563eb" stopOpacity={0.8}/>
                <stop offset="100%" stopColor="#2563eb" stopOpacity={0.4}/>
              </linearGradient>
            </defs>
            <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="class" axisLine={false} tickLine={false} tick={<CustomTick />} interval={0} />
            <YAxis axisLine={false} tickLine={false} tick={{ fill: '#cbd5e1', fontSize: 12 }} domain={[0, 100]} />
            <Tooltip contentStyle={{ borderRadius: 12, border: 'none', boxShadow: '0 2px 8px #0001' }} labelStyle={{ color: '#64748b' }} />
            <Bar dataKey="rate" fill="url(#colorAttendanceBarVerticalClassComparison)" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
} 